import styled, { css } from "styled-components";
import { CubeBannerBox } from "./styles.index";

export const AnimationDuration = 16;

export const ZoomCardBox = styled.a`
	display: flex;
	min-height: 7.90625rem;
	/* height: 7.1875rem; */
	align-items: center;
	justify-content: center;
	width: calc((100vw - 1.4rem) / 4);

	img {
		animation-duration: ${AnimationDuration}s;
		animation-timing-function: ease-in-out;
		animation-iteration-count: infinite;
		animation-fill-mode: forwards;
		width: 100%;
		height: 100%;
		object-fit: contain;
	}

	${(props: { isDraging: boolean; aspectRatio?: number }) => {
		if (props.aspectRatio) {
			return css`
				height: calc(((100vw - 1.4rem) / 4) * ${props.aspectRatio});
			`;
		}
		if (props.isDraging) {
			return {
				img: {
					"animation-play-state": props.isDraging ? "paused" : "running",
				},
			};
		}
		return "";
	}}
`;

export const ZoomBox = styled(CubeBannerBox)`
	transition-duration: 1000ms;
	transition-timing-function: ease-out;
	overflow-x: visible;

	& > * {
		&:nth-child(4n),
		&:nth-child(4n + 1) {
			img {
				width: 80%;
			}
		}

		&:nth-child(4n + 1) {
			img {
				animation-name: AzureDragon;
			}
		}

		&:nth-child(4n + 2) {
			img {
				animation-name: WhiteTiger;
			}
		}

		&:nth-child(4n + 3) {
			img {
				animation-name: VermilionBird;
			}
		}

		&:nth-child(4n) {
			img {
				animation-name: BlackTortoise;
			}
		}
	}
`;
